import * as ActionAuth from '../../../../core/action/Auth';
import * as ActionInvoice from '../../../action/Report/InvoiceReport/ActionSetFormInvoice';
import * as ActionLogin from '../../../../module/Login/Store';
import * as toggle from '../../../action/toggle';

import { Modal, message } from 'antd';
import { call, put, select, takeLatest } from 'redux-saga/effects';

import axios from 'axios';
import moment from 'moment';

export function* S_getDownloadInvoice(action: any) {
  const state = yield select();
  const isMonthly = state.Report.InvoiceReport.CheckboxIsMonth;
  const isDetail = state.Report.InvoiceReport.RadiobuttonIsDetailInvoice;
  const isMonthlyFormat =
    state.Report.InvoiceReport.CheckboxIsMonth === false
      ? 'YYYYMMDD'
      : 'YYYYMM';
  const DateStart = moment(state.Report.InvoiceReport.CycleDateStart).format(
    isMonthlyFormat
  );
  const key = 'download';
  function ResponseDownload(data: any) {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    const file_name = `${'Invoice ' + DateStart}.zip`;
    link.href = url;
    link.setAttribute('download', file_name);
    document.body.appendChild(link);
    link.click();
  }
  const CycleDateStart = moment(
    state.Report.InvoiceReport.CycleDateStart
  ).format(isMonthlyFormat);
  const IdCustomer = state.Report.InvoiceReport.CustomerId;
  const IdCustomerProduct = state.Report.InvoiceReport.CustomerProductId;
  const token = state.Auth.Token;
  const statusTokenRefresh = state.Auth.StatusTokenRefresh;
  const config = {
    Authorization: `bearer ${token}`,
    'Content-type': 'application/json',
  };
  try {
    yield put(toggle.changeLoadingTrue());

    const { data } = yield call(
      axios.post,
      process.env.REACT_APP_URL + '/Delivery/DownloadInvoiceExcel',
      {
        customerCode: IdCustomer,
        detail: isDetail,
        monthly: isMonthly,
        cycle: CycleDateStart,
        customerProducts: IdCustomerProduct,
      },
      {
        responseType: 'arraybuffer',
        headers: config,
        onDownloadProgress: (progressEvent: any) => {
          const { loaded, total } = progressEvent;
          let percentProgress = Math.floor((loaded * 100) / total);

          // let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);

          if (percentProgress < 100) {
            message.loading({
              content: 'Loading ' + percentProgress + '%',
              key,
            });
          } else if (percentProgress === 100) {
            Modal.destroyAll();
            message.success({
              content: 'Download Berhasil',
              key,
              duration: 1.5,
            });
          } else if (percentProgress === Infinity) {
            Modal.destroyAll();
            message.error({
              content: 'Download Gagal',
              key,
              duration: 3,
            });
          }
        },
      }
    );
    ResponseDownload(data);
    if (statusTokenRefresh === true) {
      yield put(ActionAuth.changeStatusTokenRefresh(false));
    }
    yield put(ActionInvoice.clearAllFormInvoice());
    yield put(toggle.changeLoadingFalse());
  } catch (error) {
    if (error.response.status === 500) {
      message.error({
        content: 'Download Gagal',
        key,
        duration: 3,
      });
    }
    yield put(ActionLogin.errorHandling(action, error));
  }
}

export function* SM_getDownloadInvoice() {
  yield takeLatest('DOWNLOAD_INVOICE', S_getDownloadInvoice);
}
